import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const supportedLanguages = ["en", "es", "fr", "it", "de"];
const languageAliases = {
  spanish: "es",
  espanol: "es",
  español: "es",
  english: "en",
  ingles: "en",
  inglés: "en",
  french: "fr",
  frances: "fr",
  francés: "fr",
  italian: "it",
  italiano: "it",
  german: "de",
  aleman: "de",
  alemán: "de"
};

const normalizeLanguage = (language) => {
  if (!language || typeof language !== "string") {
    return "";
  }
  const normalized = language.trim().toLowerCase().replace(/_/g, "-");
  const base = normalized.split("-")[0];
  return languageAliases[base] || base;
};

const getLocaleBasePath = () => {
  const publicUrl = String(process.env.PUBLIC_URL || "").trim();
  if (publicUrl) {
    return publicUrl.replace(/\/+$/, "");
  }
  if (typeof window === "undefined") {
    return "";
  }
  return "";
};

export const applyPreferredLanguage = (language) => {
  const normalized = normalizeLanguage(language);
  if (!supportedLanguages.includes(normalized)) {
    return false;
  }
  i18n.changeLanguage(normalized);
  localStorage.setItem("i18nextLng", normalized);
  return true;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (languages, namespaces) =>
        `${getLocaleBasePath()}/locales/${languages[0]}/${namespaces[0]}.json`
    },
    fallbackLng: "es",
    supportedLngs: supportedLanguages,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    },
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false
    },
    debug: false
  });

export default i18n;
